module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_2.01c4b52af8044f66e5ae7468cb48ad34.png";